export const color = {
  darkGreen: '#188369',
  green: '#1b9779',
  lightGreen: '#46b090',
  darkPink: '#b05088',
  pink: '#d870ad',
  lightGray: '#e6e9ee',
  gray: '#ccd0d9',
  darkGray: '#aab2bd'
};

export const mainColors = {
  primary: color.darkGreen,
  primaryDark: color.green,
  secondary: color.darkPink,
  secondaryDark: color.pink
};

export const colorMono = {
  white: '#ffffff',
  black: '#000000'
};

export const colorGray = {
  primary: colorMono.black,
  secondary: color.darkGray,
  colored: mainColors.primary
};

export const colorText = {
  primary: colorMono.black,
  secondary: color.darkGray,
  colored: mainColors.primary
};

export const colors = {
  color,
  mainColors,
  colorText,
  colorMono,
  colorGray
};
